/*
 * A selection of functions called via scroll (fullpage)
 * callback to implement non-css design inclusions
 *
 * @author BarrelNY
 *
 */
var ScrollUtil = {
	init:function(){
		this.events();
	},

	events:function(){
		$('body')
			//Transperant slide functionality
			.on('fullPage__onLeave',this.bypassQuote.bind(this))
			//The black divider between sections
			.on('fullPage__onLeave',this.showDivider.bind(this))
			.on('fullPage__afterLoad',this.hideDivider.bind(this))
			//Scroll event toggling
			.on('fullPage__afterLoad',this.enableScrollEvents.bind(this))
			.on('fullPage__onLeave',this.disableScrollEvents.bind(this));

	},

	/*
	 * The designs include a black bar between 100% height
	 * sections. This functions add the black bar. "hideDivider"
	 * takes it away after the scroll animation
	 *
	 * @param	obj	event object
	 * @param	string	index we're moving away from
	 * @param	string	index we're moving towards
	 * @param	string	the direction we are going
	 * @returns	void
	 */
	showDivider:function(e,index, nextIndex, direction){
		if ( MUR.isSmall() ) return;

		var
			isHome  = $('body').hasClass('home'),
			$curr   = $('.fullpage-wrapper').find('[class^=section-]').eq(nextIndex-1),
			$divide = $('<div class="divider">').hide();

		// Don't show divider after hero on homepage
		// Don't show the divider before transperant section on home
		// Don't show divider after transperant section anytime
		if (
			(index == 1) ||
			(isHome && index == 2 && direction == 'up') ||
			(index == 2 && direction == 'down') ||
			(index == 3 && direction == 'up')
		) return true;

		if (direction == 'up'){
			$divide.css({top:'auto',bottom:'-25px'})
		}

		$curr.prepend($divide);
		$divide.fadeIn(50);
	},

	/*
	 * Remove the divider from the DOM once
	 * the scroll animation is finito
	 *
	 * @param	obj	event object
	 * @param	string	anchor link corresponding to the section
	 * @param	string	current section index
	 * @returns	void
	 */
	hideDivider:function(e,anchorLink,index){
		var $curr = $('.fullpage-wrapper').find('[class^=section-]').eq(index-1);
		if ( $curr.is('.section-last') ) return;

		$('.divider').fadeOut(100,function(){
			$(this).remove();
		});
	},

	/*
	 * Skip a step on the U1 template
	 *
	 * @param	obj	event object
	 * @param	string	index we're moving away from
	 * @param	string	index we're moving towards
	 * @param	string	the direction we are going
	 * @returns	void
	 */
	bypassQuote:function(e,index, nextIndex, direction){
		if (
			MUR.isSmall() || $('body').hasClass('home') || nextIndex != 2
		) return;

		$('body').trigger('fullPage__disableInteractions');

		if (direction == 'down'){
			setTimeout(function(){
				//Slow it down
				$.fn.fullpage.setScrollingSpeed((MUR.animation.duration/4)*7);
				//Moooove it
				$.fn.fullpage.moveTo(3);
				//Revert
				$.fn.fullpage.setScrollingSpeed(MUR.animation.duration);
			},30);
		}
	},

	/*
	 * Re-instate scroll events
	 *
	 * @params	void
	 * @returns	void
	 */
	enableScrollEvents:function(){
		if ( $('body').hasClass('home') )
			$('body').trigger('fullPage__enableInteractions');
	},

	/*
	 * Don't allow scroll events while animating
	 *
	 * @params	void
	 * @returns	void
	 */
	disableScrollEvents:function(){
		if ( $('body').hasClass('home') )
			$('body').trigger('fullPage__disableInteractions');
	},

	/*
	 * Prep for re-init
	 * @param	void
	 * @returns void
	 */
	drop:function(){
		$('body')
			.off('fullPage__onLeave',this.bypassQuote.bind(this))
			.off('fullPage__onLeave',this.showDivider.bind(this))
			.off('fullPage__afterLoad',this.hideDivider.bind(this))
			.off('fullPage__afterLoad',this.enableScrollEvents.bind(this))
			.off('fullPage__onLeave',this.disableScrollEvents.bind(this));
	}
}

module.exports = ScrollUtil;
